/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Added_TagInputs */

const en_us2_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added`)
};

const pt_br2_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado`)
};

const es_419_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregado`)
};

const pt_pt2_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado`)
};

const fr_fr2_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté`)
};

const de_de2_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzugefügt`)
};

const it_it2_workout_added_tag = /** @type {(inputs: Workout_Added_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiunto`)
};

/**
* | output |
* | --- |
* | "Added" |
*
* @param {Workout_Added_TagInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_added_tag = /** @type {((inputs?: Workout_Added_TagInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Added_TagInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_added_tag(inputs)
	if (locale === "es-419") return es_419_workout_added_tag(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_added_tag(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_added_tag(inputs)
	if (locale === "de-DE") return de_de2_workout_added_tag(inputs)
	if (locale === "it-IT") return it_it2_workout_added_tag(inputs)
	return en_us2_workout_added_tag(inputs)
});
export { workout_added_tag as "workout.added_tag" }